module.exports = __webpack_public_path__ + "img/linkedin.8fed6dc.svg";